import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './PanelTop.css'

const propTypes = {
    children: PropTypes.node.isRequired,
    isDemo: PropTypes.bool,
}

const PanelTop = (props) => {
    const classNameBase = classNames(styles.base, {
        [styles.isDemo]: !!props.isDemo,
    })

    return (
        <div className={classNameBase}>
            <div className={styles.inner}>{props.children}</div>
        </div>
    )
}

PanelTop.propTypes = propTypes

export default PanelTop



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/PanelTop/PanelTop.jsx